import { FileShareDiscoveryRangeModel } from '../../microsoft/fileshare/file-share-discovery-range-model';

export class FileShareDiscoveriesModel {
  ranges: FileShareDiscoveryRangeModel[];
}
